import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _inherits from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/label/labelview
 */
import View from "../view";
import "../../theme/components/label/label.css";
/**
 * The label view class.
 *
 * @extends module:ui/view~View
 */

var LabelView = /*#__PURE__*/function (_View) {
  _inherits(LabelView, _View);

  var _super = _createSuper(LabelView);

  /**
   * @inheritDoc
   */
  function LabelView(locale) {
    var _this;

    _classCallCheck(this, LabelView);

    _this = _super.call(this, locale);
    /**
     * The text of the label.
     *
     * @observable
     * @member {String} #text
     */

    _this.set('text');
    /**
     * The `for` attribute of the label (i.e. to pair with an `<input>` element).
     *
     * @observable
     * @member {String} #for
     */


    _this.set('for');

    var bind = _this.bindTemplate;

    _this.setTemplate({
      tag: 'label',
      attributes: {
        class: ['ck', 'ck-label'],
        for: bind.to('for')
      },
      children: [{
        text: bind.to('text')
      }]
    });

    return _this;
  }

  return LabelView;
}(View);

export { LabelView as default };